module.exports = __webpack_public_path__ + "img/happybirthday.41f28879.png";